
import classnames from 'classnames'
import Composer from 'components/Composer'
import ConversationHistory from 'components/ConversationHistory'
import Footer from 'components/Footer'
import MessageGroupList from 'components/MessageGroupList'
import RateConversation from 'components/RateConversation'
import useComposerState from 'hooks/useComposerState'
import useTimedMessages from 'hooks/usedTimedMessages'
import useHasFooter from 'hooks/useHasFooter'
import useSendMessage from 'hooks/useSendMessage'
import { getActiveConversationId,getVisibleActiveConversationMessages } from 'modules/conversations/selectors'
import { groupMessages, isRateConversationCTAMessage } from 'modules/message/utils'
import { isEmpty, last } from 'ramda'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ConversationId } from 'types/conversation'
import { Message } from 'types/message'

const LandingPageMessageView = () => {
  const composerState = useComposerState()
  const { sendMessage } = useSendMessage()

  const hasFooter = useHasFooter()
  const messagesList = useSelector(getVisibleActiveConversationMessages)
  const activeConversationId: ConversationId = useSelector(getActiveConversationId)

  const timedMessages = useTimedMessages(messagesList, activeConversationId)
  const messageGroups = useMemo(() => groupMessages(timedMessages), [timedMessages])


  const rateConversationMessage: Message = useMemo(() => {
    if (timedMessages && timedMessages.length) {
      const lastMessage = last(timedMessages)
      if (!!lastMessage && isRateConversationCTAMessage(lastMessage)) {
        return lastMessage
      }
    }
    return null
  }, [timedMessages])

  const isAskingForConversationRating = activeConversationId && !!rateConversationMessage

  return (
    <>
      { false && <ConversationHistory/> } { /* Adding as a temporary unused import due to css module issues */}
      <div
        className={classnames('drift-widget-message-history', {
          'drift-widget-message-history--with-footer': hasFooter
        })}
      >
        <MessageGroupList
          messageGroups={messageGroups}
          messages={timedMessages}
          reflowHidden={false}
          disabled={false}
          inheritBackgroundStyle={true}
          showTimestampForFirstGroup={false}
        />
      </div>

      { isAskingForConversationRating &&
        <div className="drift-widget-landingpage-bottom">
          <RateConversation message={rateConversationMessage} />
        </div>
      }
      { !isAskingForConversationRating && !isEmpty(messagesList) &&
        <div className="drift-widget-landingpage-bottom">
          <Composer
            state={composerState}
            disabled={false}
            alwaysShow={true}
            onSubmit={sendMessage}
            chatHidden={false}
            activeConversationId={activeConversationId}
            alwaysShowSendAction={true}
            useGifPicker={false}
          />
          <Footer />
        </div>
      }
    </>
  )
}

export default LandingPageMessageView
